export default {
  name: 'search-common-form',

  ui: {
    btSubmit: '[js-search-common-form-submit]',
    // btClear: '[js-search-common-form-clear]',
    input: '[js-search-common-form-input]',
  },

  events: [
    {
      target: 'btSubmit',
      on: 'click',
      handle () {
        this.goToURL()
      },
    },
    /* {
      target: 'btClear',
      on: 'click',
      handle () {
        if (this.ui.input.value !== '') {
          this.ui.input.value = ''
        }
      },
    }, */
  ],

  componentDidMount () {
    this.el.classList.add('has-transition')

    this.ui.input.addEventListener('keydown', this.keyboardListener)
  },

  componentWillUnmount () {
    this.ui.input.removeEventListener('keydown', this.keyboardListener)
  },

  keyboardListener (e) {
    var key = e.which || e.keyCode
    // console.log(key)
    if (key === 13) {
      // 13 is enter
      this.goToURL()
    } else if (key === 27 || key === 'Escape') {
      // 27 is escape
      this.ui.btClear.click()
    }
  },

  strip (html) {
    let doc = new DOMParser().parseFromString(html, 'text/html')
    return doc.body.textContent || ''
  },

  goToURL () {
    // console.log('this.ui.input.value', this.ui.input.value)
    if (this.ui.input.value !== '') {
      const query = this.strip(this.ui.input.value)
      // const urlPrefix = window.lang === 'fr' ? 'recherche' : 'search'
      let url = `${this.props.url}?query=${query}`
      window.location.href = url
    }
  },
}
